var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "announcement-create loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "b-row",
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 12,
                    "form-context": _vm.initialFormContexts.announcement,
                    "show-buttons": false,
                    title: "Neue Ankündigung",
                  },
                  on: { save: _vm.saveAnnouncement },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Inhalt",
                          property: "announcement",
                          required: "",
                          "show-label": false,
                          type: "ckeditorReduced",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-2",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Gültig ab",
                          "max-date": null,
                          property: "dateBegin",
                          type: "datepicker",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-2",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Gültig bis",
                          "max-date": null,
                          property: "dateEnd",
                          type: "datepicker",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-2",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Wie oft anzeigen? (0 = unbegrenzt)",
                          property: "maxOccurrence",
                          type: "number",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-4",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Zielgruppe",
                          property: "roleGroup",
                          type: "checkboxGroup",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-2",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Gebiet",
                          property: "area",
                          type: "autocomplete",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Firma",
                          "options-loader": _vm.loadFirmOptions,
                          property: "firm",
                          type: "autocomplete",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Firmengruppe",
                          "options-loader": _vm.loadFirmGroupOptions,
                          property: "firmGroup",
                          type: "autocomplete",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-3",
                        attrs: {
                          "form-context": _vm.initialFormContexts.announcement,
                          label: "Zuordnung",
                          "options-loader": _vm.loadFirmAssociationOptions,
                          property: "firmAssociation",
                          type: "autocomplete",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "font-weight-bold" }, [
                            _vm._v("Bild"),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-muted mb-2" }, [
                            _vm._v(
                              "\n                        Platzhalter für die Bildposition im Text:\n                        "
                            ),
                            _c("code", { pre: true }, [
                              _vm._v("{{ ankuendigung.bild }}"),
                            ]),
                            _vm._v(" "),
                            _vm.uploadedFileId
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { title: "Bild entfernen" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.removeFile.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "inticon-autoclaim_delete",
                                      staticStyle: { "font-size": "1.5rem" },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.uploadedFileId
                            ? _c("b-img", {
                                staticClass: "announcement-image-preview",
                                attrs: {
                                  fluid: "",
                                  src: `/api/desktop/announcements/files/${_vm.uploadSessionId}/${_vm.uploadedFileId}`,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.uploadedFileId
                            ? _c("csp-base-file-upload", {
                                attrs: {
                                  "accepted-mime-types": "image/jpeg,image/png",
                                  "additional-params": _vm.fileUploadParams,
                                  "max-files": 1,
                                  "upload-url":
                                    "/api/desktop/announcements/files",
                                },
                                on: {
                                  "upload-complete":
                                    _vm.handleFileUploadComplete,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  [
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c("b-col", { attrs: { cols: "6" } }),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "text-right", attrs: { cols: "6" } },
                          [
                            _vm.showPreviewButton
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      disabled: _vm.isLoadingPreview,
                                      variant: "primary",
                                    },
                                    on: { click: _vm.openPreview },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Vorschau\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-2",
                                attrs: { variant: "secondary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push(
                                      "/de/Schaden-Manager/Dokument/announcements"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Abbrechen\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.saveAnnouncement(
                                      _vm.initialFormContexts.announcement
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Speichern\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPreviewModalOpen
        ? _c("csp-announcements", {
            attrs: {
              "acknowledge-url": "",
              "announcement-html": _vm.previewHtml,
              "announcement-ids": [],
              "show-confirm": false,
            },
            on: {
              hidden: function ($event) {
                _vm.isPreviewModalOpen = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }